var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"download-content"},[(_vm.device == 'h5')?_c('syCom'):_c('syPcCom')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }